import api from './api';

/**
 * Hashtags Service
 *
 * Connects to backend hashtag generation API endpoints
 */

// ============================================================================
// Types
// ============================================================================

export interface HashtagResult {
  id: string;
  value: string;
  score: number;
}

export interface GenerateHashtagsRequest {
  term: string;
  country?: string;
}

export interface GenerateHashtagsResponse {
  hashtags: HashtagResult[];
  term: string;
  country: string;
  source: 'ai' | 'synthetic' | 'cache';
}

// ============================================================================
// Service Functions
// ============================================================================

export const hashtagsService = {
  /**
   * Generate hashtags based on a seed term
   *
   * POST /api/hashtags/generate
   *
   * @param data - Hashtag generation request
   * @returns Array of hashtag objects with id, value, and score
   */
  generate: async (data: GenerateHashtagsRequest): Promise<HashtagResult[]> => {
    const response = await api.post<{ success: boolean; data: GenerateHashtagsResponse }>('/api/hashtags/generate', {
      term: data.term,
      country: data.country || 'US',
    });
    return response.data.data.hashtags;
  },
};

export default hashtagsService;
